/***************************************************************************************************

 Copyright 2023-2024 Fannie Mae. All rights reserved.
 This software contains confidential information and trade secrets of Fannie Mae.
 Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.

 ****************************************************************************************************/

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ErrorComponent} from './component/error/error.component';
import {DD_DashboardComponent} from "./due-diligence/dashboard/dd-dashboard.component";
import {HomeComponent} from './home/home.component';
import {LoginGuard} from "./login.guard";
import {UnAuthorizedComponent} from './component/unauthorized/unauthorized.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { DirectRouteGuard } from './direct-route.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'dd_dashboard',
    component: DD_DashboardComponent,
    canActivate: [LoginGuard, DirectRouteGuard]
  },
  {
    path: 'insurance',
    component: InsuranceComponent,
    canActivate: [LoginGuard, DirectRouteGuard]
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'un-authorized',
    component: UnAuthorizedComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
